import { useContext, useEffect } from "react";
import { Colour } from "../Variables";
import { Card } from "../components/Shared/Card";
import { RouteContext } from "../../contexts/RoutesContext";

export function PositionClosed() {
    const routeContext = useContext(RouteContext);
    useEffect(() => {
        routeContext.setRoutes([{ name: "Position closed", route: null }])
    }, []);

    return (
        <Card title={"Position closed"} headerTheme={Colour.Alt} headerClasses={""} >
            This position is now closed.
        </Card>
    );
}